export function determineCandlePatternCandleDuration(setupDetails) {
  return setupDetails.candleDuration;
}
